import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Form, Button, Modal, Toast, ToastContainer, Alert } from 'react-bootstrap';
import { Pencil, Plus, Trash, ListTask } from 'react-bootstrap-icons'; 
import Select from 'react-select';
import api from '../api';

const Ventanillas = () => {
  const userRole = localStorage.getItem('role');
  const idSala = parseInt(localStorage.getItem('id_sala'), 10);
  const maxVentanillas = parseInt(localStorage.getItem('numventanillas'), 10);
  const [turnoInicial, setTurnoInicial] = useState(null); 
  const [ventanillas, setVentanillas] = useState([]);
  const [relaciones, setRelaciones] = useState([]);
  const [serviciosDisponibles, setServiciosDisponibles] = useState([]);
  const [selectedVentanilla, setSelectedVentanilla] = useState(null);
  const [filteredVentanillas, setFilteredVentanillas] = useState([]);
  const [search, setSearch] = useState('');
  const [ventanillaAEliminar, setVentanillaAEliminar] = useState(null);
  const [relacionAEliminar, setRelacionAEliminar] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditandoRelacion, setIsEditandoRelacion] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isSavingRelacion, setIsSavingRelacion] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRelacionModal, setShowRelacionModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorsRelacion, setErrorsRelacion] = useState({});
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });
  const [tipoEliminacion, setTipoEliminacion] = useState(null); // 'ventanilla' o 'relacion'
  const [newRelacion, setNewRelacion] = useState({
    idServicio: '',
    Prioridad: '',
    Cant: '',
  });

  const normalizeText = (text) => {
    return text
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, ""); // quita acentos
  };

  const mostrarToast = (variant, message) => {
    setToast({ show: true, variant, message });

    setTimeout(() => {
      setToast({ ...toast, show: false });
    }, 3000);
  };

  useEffect(() => {
    api.get('/ventanillas')
      .then(res => {
        setVentanillas(res.data);
        setFilteredVentanillas(res.data);
      })
      .catch(err => {
        console.error('error al obtener ventanillas', err);
      });
  }, []);

  useEffect(() => {
    const result = ventanillas.filter(item =>
      (item.Ventanilla && normalizeText(item.Ventanilla).includes(normalizeText(search))) ||
      (item.Servicio && normalizeText(item.Servicio).includes(normalizeText(search)))
    );
    setFilteredVentanillas(result);
  }, [search, ventanillas]);

  const handleEditClick = (ventanilla) => {
    setIsEditing(true);
    setErrors({});
    setTurnoInicial(ventanilla.Turno);
    setSelectedVentanilla({ ...ventanilla }); // clona el objeto
    setShowModal(true);
  };

  const handleAddClick = () => {
    if(ventanillas.length >= maxVentanillas ){
      mostrarToast('info', 'No es posible crear una nueva ventanilla. Por favor comuníquese con soporte al correo siteturnos@sitesas.co');
    }else{
      setIsEditing(false);
      setTurnoInicial(null);
      setSelectedVentanilla({
        Ventanilla: '',
        Servicio: '',
        Turno: null,
        api: 0,
        reasignar: 0,
        procedimiento: '',
        IdSala: idSala,
      });
      setErrors({});
      setShowModal(true);
    }
  };

  const handleInputChange = (e) => {
    setSelectedVentanilla({
      ...selectedVentanilla,
      [e.target.name]: e.target.value
    });
  };

  const handleRelacionInputChange = (e) => {
    const { name, value } = e.target;
    setNewRelacion(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!selectedVentanilla.Ventanilla?.trim()) {
      newErrors.Ventanilla = "Campo requerido";
    } else if (selectedVentanilla.Ventanilla.trim().length > 5) {
      newErrors.Ventanilla = "No debe superar los 5 caracteres";
    }else {
      const mismaVentanillaYaExiste = ventanillas.some(ven =>
        ven.Ventanilla === selectedVentanilla.Ventanilla.trim() &&
        ven.id !== selectedVentanilla.id // permite que conserve su propia prioridad al editar
      );

      if (mismaVentanillaYaExiste) {
        newErrors.Ventanilla = 'Existe una ventanilla con este nombre.';
      }
    }

    if(selectedVentanilla.reasignar === 1 && !selectedVentanilla.procedimiento?.trim()) {
      newErrors.procedimiento = "Campo requerido";
    }

    if(!selectedVentanilla.procedimiento?.trim()) {
      selectedVentanilla.Turno = turnoInicial;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarRelacion = () => {
    const newErrors = {};

    //valida el servicio duplicado
    const servicioYaExiste = relaciones.some(rel =>
      Number(rel.idServicio) === Number(newRelacion.idServicio) && rel.id !== newRelacion.id
    );

    if (!newRelacion.idServicio) {
      newErrors.idServicio = 'Seleccione un servicio.';
    }else if(servicioYaExiste){
      newErrors.idServicio = 'Este servicio ya está asignado a la ventanilla';
    }

    //valida la prioridad duplicada
    if (!newRelacion.Prioridad) {
      newErrors.Prioridad = 'Seleccione la prioridad.';
    }else {
      const mismaPrioridadYaExiste = relaciones.some(rel =>
        Number(rel.Prioridad) === Number(newRelacion.Prioridad) &&
        rel.id !== newRelacion.id // permite que conserve su propia prioridad al editar
      );

      if (mismaPrioridadYaExiste) {
        newErrors.Prioridad = 'Existe una relación con esta prioridad.';
      }
    }

    //valida cantidad
    if (!newRelacion.Cant || newRelacion.Cant <= 0) newErrors.Cant = 'Ingrese una cantidad válida.';

    setErrorsRelacion(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = () => {
    if (!validate()) return;

    setIsSaving(true);
    api.put(`/ventanillas/${selectedVentanilla.id}`, selectedVentanilla)
      .then((res) => {
        const updatedList = ventanillas.map(item =>
          item.id === selectedVentanilla.id ? res.data.data : item
        );
        setVentanillas(updatedList);
        setFilteredVentanillas(updatedList);
        setShowModal(false);
        mostrarToast('success', 'Ventanilla actualizada correctamente.');
      })
      .catch((err) => {
        console.error('Error al actualizar:', err);
        mostrarToast('danger', 'Error al actualizar la ventanilla.');
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleCreate = () => {
    if (!validate()) return;
    setIsSaving(true);
    api.post('/ventanillas', selectedVentanilla)
      .then((res) => {
        const nuevo = res.data.data;
        const nuevaLista = [...ventanillas, nuevo];
        setVentanillas(nuevaLista);
        setFilteredVentanillas(nuevaLista);
        setShowModal(false);
        mostrarToast('success', 'Ventanilla creada correctamente.');
      })
      .catch((err) => {
        console.error('Error al crear:', err);
        mostrarToast('danger', 'Error al crear la ventanilla.');
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleDeleteClick = (row) => {
    setVentanillaAEliminar(row);
    setTipoEliminacion('ventanilla');
    setShowDeleteModal(true);
  };

  const handleEliminarRelacion = (rel) => {
    setRelacionAEliminar(rel);
    setTipoEliminacion('relacion');
    setShowDeleteModal(true);
  };

  const confirmarEliminacion = () => {
    setIsDeleting(true);

    if (tipoEliminacion === 'ventanilla') {
      api.delete(`/ventanillas/${ventanillaAEliminar.id}`)
        .then(() => {
          const nuevaLista = ventanillas.filter(item => item.id !== ventanillaAEliminar.id);
          setVentanillas(nuevaLista);
          setFilteredVentanillas(nuevaLista);
          setVentanillaAEliminar(null);
          mostrarToast('success', 'Ventanilla eliminada correctamente.');
        })
        .catch((err) => {
          console.error('Error al eliminar:', err);
          mostrarToast('danger', 'Error al eliminar la ventanilla.');
        })
        .finally(() => {
          setIsDeleting(false);
        });
    } else if (tipoEliminacion === 'relacion') {
      api.delete(`/relaciones/${relacionAEliminar.id}`)
        .then(() => {
          const nuevasRelaciones = relaciones.filter(r => r.id !== relacionAEliminar.id);
          setRelaciones(nuevasRelaciones);
          mostrarToast('success', 'Relación eliminada correctamente.');
          api.get('/ventanillas')
            .then(res => {
              setVentanillas(res.data);
              setFilteredVentanillas(res.data);
            })
            .catch(err => {
              console.error('error al obtener ventanillas', err);
            });
        })
        .catch(() => mostrarToast('danger', 'Error al eliminar la relación.'))
        .finally(() => {
          setIsDeleting(false);
        });
    }
    setShowDeleteModal(false);
  };

  const handleRelationClick = (row) => {
    setSelectedVentanilla(row);
    setErrorsRelacion({});

    // Obtener relaciones actuales para la ventanilla
    api.get(`/ventanillas/${row.Ventanilla}/servicios`)
      .then(res => setRelaciones(res.data))
      .catch(() => mostrarToast('danger', 'Error al cargar los servicios'));
    setShowRelacionModal(true);

    // Obtener servicios disponibles
    api.get('/servicios')
      .then(res => setServiciosDisponibles(res.data))
      .catch(err => console.error('Error cargando servicios:', err));

  }

  // Opciones de servicios
  const opciones = serviciosDisponibles.map(servicio => ({
      value: servicio.idServicio,
      label: servicio.Servicio,
      visible: servicio.visible,
  }));

  // Opciones de prioridad del 1 al 10
  const prioridadOptions = [...Array(10)].map((_, i) => ({
    value: i + 1,
    label: `${i + 1}`
  }));

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.data.visible === 1 ? '#d4edda' : '#f8d7da',
      color: '#000',
    }),
  };

  const handleAgregarRelacion = () => {
    if (!validarRelacion()) return;

    setIsSavingRelacion(true);
    const payload = {
      Ventanilla: parseInt(selectedVentanilla.Ventanilla, 10),
      idServicio: parseInt(newRelacion.idServicio, 10),
      Prioridad: parseInt(newRelacion.Prioridad, 10),
      Cant: parseInt(newRelacion.Cant, 10),
      IdSala: idSala,
    };

    api.post('/relaciones', payload)
      .then(res => {
        api.get(`/ventanillas/${selectedVentanilla.Ventanilla}/servicios`)
          .then(resp => {
            setRelaciones(resp.data);
            setNewRelacion({ idServicio: '', Prioridad: '', Cant: '' });
            setErrorsRelacion({});
            mostrarToast('success', 'Asignación creada correctamente.');
          });

        api.get('/ventanillas')
          .then(res => {
            setVentanillas(res.data);
            setFilteredVentanillas(res.data);
          })
          .catch(err => {
            console.error('error al obtener ventanillas', err);
          });
      })
      .catch(() => {
        mostrarToast('danger', 'Error al crear la asignación.');
      })
      .finally(() => {
        setIsSavingRelacion(false);
      });

  };

   const handleEditarRelacion = (rel) => {
    setNewRelacion({
      id: rel.id,
      idServicio: rel.idServicio,
      Prioridad: rel.Prioridad,
      Cant: rel.Cant,
    });
    setIsEditandoRelacion(true);
  };

  const handleActualizarRelacion = () => {
    if (!selectedVentanilla || !newRelacion.id) return;
    if (!validarRelacion()) return;

    setIsSavingRelacion(true);
    api.put(`/relaciones/${newRelacion.id}`, {
      Ventanilla: parseInt(selectedVentanilla.Ventanilla, 10),
      idServicio: parseInt(newRelacion.idServicio, 10),
      Prioridad: parseInt(newRelacion.Prioridad, 10),
      Cant: parseInt(newRelacion.Cant, 10)
    })
      .then(res => {
        api.get(`/ventanillas/${selectedVentanilla.Ventanilla}/servicios`)
          .then(resp => {
            setRelaciones(resp.data);
            setNewRelacion({ idServicio: '', Prioridad: '', Cant: '' });
            setErrorsRelacion({});
            mostrarToast('success', 'Asignación creada correctamente.');
          });
        setIsEditandoRelacion(false);
      })
      .catch(() => {
        mostrarToast('danger', 'Error al actualizar la asignación.');
      })
      .finally(() => {
        setIsSavingRelacion(false);
      });
  };

  const columns = [
    { name: 'Número Ventanilla', selector: row => row.Ventanilla, sortable: true },
    { name: 'Servicio', selector: row => row.relaciones_count > 0 ? 'Multi servicios' : row.Servicio, sortable: true },
    {
      name: 'Opciones',
      cell: row => (
        <div className="d-flex gap-2">
          {userRole !== 'consulta' && (
            <>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => handleEditClick(row)}
              >
                <Pencil />
              </Button>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => handleDeleteClick(row)}
              >
                <Trash />
              </Button>
            </>
          )}
          
          {Number.isInteger(Number(row.Ventanilla)) && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleRelationClick(row)}
            >
              <ListTask />
            </Button>
          )}
        </div>
      ),
      ignoreRowClick: true,
      button: true,
      style: {
        justifyContent: 'flex-start',
        minWidth: '140px', // ajusta según el número de botones
        maxWidth: '160px',
      }
    },
  ];

  return (
    <div className="mt-4" style={{ overflowX: 'auto' }}>
      <DataTable
        title="Listado de Ventanillas"
        columns={columns}
        data={filteredVentanillas}
        pagination
        highlightOnHover
        responsive
        striped
        subHeader
        subHeaderComponent={
          <div className="d-flex justify-content-between w-100">
            {userRole !== 'consulta' && (
              <Button variant="outline-success" size="sm" onClick={handleAddClick}>
                Nuevo <Plus />
              </Button>
            )}
            <input
              type="text"
              className="form-control w-25"
              placeholder="Buscar..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        }
      />

      {/* Modal de Edición */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Editar Ventanilla' : 'Nueva Ventanilla'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {userRole === 'admin' && !isEditing && (
            <>
              <Alert variant="info">
                <strong>Nota:</strong> Recuerde al momento de crear la ventanilla <strong>consultorio</strong> ó <strong>quirófano</strong> debe ir a la tabla <strong>llamado</strong> e ingresar la sigla correspondiente.<br></br>(C - consultorio, QX - Quirófano).
                <br></br><br></br>
                <strong>Importante:</strong><br />
                Recuerde asignar la ventanilla <strong>consultorio</strong> ó <strong>quirófano</strong> a una o más <strong>pantallas</strong>.
                Si no lo hace, <strong>los llamados de esta ventanilla no se visualizarán</strong>.
              </Alert>
              
            </>
            
          )}
          {selectedVentanilla && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Número Ventanilla</Form.Label>
                <Form.Control
                  type="text"
                  name="Ventanilla"
                  value={selectedVentanilla.Ventanilla}
                  onChange={handleInputChange}
                  isInvalid={!!errors.Ventanilla}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Ventanilla}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Servicio</Form.Label>
                <Form.Control
                  type="text"
                  name="Servicio"
                  value={selectedVentanilla.Servicio}
                  onChange={handleInputChange}
                  isInvalid={!!errors.Servicio}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Servicio}
                </Form.Control.Feedback>
              </Form.Group>
              {userRole === 'admin' && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Procedimiento</Form.Label>
                    <Form.Control
                      type="text"
                      name="procedimiento"
                      value={selectedVentanilla.procedimiento}
                      onChange={handleInputChange}
                      isInvalid={!!errors.procedimiento}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.procedimiento}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Turno</Form.Label>
                    <Form.Control
                      type="number"
                      name="Turno"
                      min={0}
                      disabled={!selectedVentanilla.procedimiento?.trim()}
                      value={!selectedVentanilla.procedimiento?.trim() ? turnoInicial : selectedVentanilla.Turno }
                      onChange={handleInputChange}
                      isInvalid={!!errors.Turno}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.Turno}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="switch"
                      label="Api"
                      name="api"
                      checked={selectedVentanilla.api === 1}
                      onChange={(e) =>
                        setSelectedVentanilla({
                          ...selectedVentanilla,
                          api: e.target.checked ? 1 : 0,
                        })
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="switch"
                      label="Reasignar consultorio"
                      name="reasignar"
                      checked={selectedVentanilla.reasignar === 1}
                      onChange={(e) =>
                        setSelectedVentanilla({
                          ...selectedVentanilla,
                          reasignar: e.target.checked ? 1 : 0,
                        })
                      }
                    />
                  </Form.Group>
                </>
              )}
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={isEditing ? handleUpdate : handleCreate}
            disabled={isSaving}
          >
            {isSaving
              ? (isEditing ? 'Guardando...' : 'Creando...')
              : (isEditing ? 'Guardar Cambios' : 'Crear Ventanilla')}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Confirmación para eliminar */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {tipoEliminacion === 'ventanilla' ? (
            <>¿Está seguro de que desea eliminar la ventanilla <strong>{ventanillaAEliminar?.Ventanilla}</strong>?</>
          ) : (
            <>¿Está seguro de que desea eliminar la asignación del servicio <strong>{relacionAEliminar?.servicio?.Servicio}</strong>?</>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger"
            onClick={confirmarEliminacion}
            disabled={isDeleting}
          >
            {isDeleting ? 'Eliminando...' : 'Eliminar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal servicios relacionados */}
      <Modal show={showRelacionModal} onHide={() => setShowRelacionModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Ventanilla {selectedVentanilla?.Ventanilla}</Modal.Title>
        </Modal.Header>
         <Modal.Body>
          <div className="row">
            {/* Columna izquierda - Formulario */}
            {userRole !== 'consulta' && (
              <div className="col-md-4 border-end">
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Servicio</Form.Label>
                    <div className={errorsRelacion.idServicio ? 'is-invalid' : ''}>
                      <Select
                        name="idServicio"
                        options={opciones}
                        styles={customStyles}
                        value={opciones.find(opt => opt.value === newRelacion.idServicio) || null}
                        onChange={selected => setNewRelacion({ ...newRelacion, idServicio: selected.value })}
                      />
                    </div>
                    {errorsRelacion.idServicio && (
                      <div className="invalid-feedback d-block">{errorsRelacion.idServicio}</div>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Prioridad</Form.Label>
                    <div className={errorsRelacion.Prioridad ? 'is-invalid' : ''}>
                      <Select
                        name="Prioridad"
                        options={prioridadOptions}
                        value={prioridadOptions.find(opt => opt.value === Number(newRelacion.Prioridad)) || null}
                        onChange={selected => setNewRelacion({ ...newRelacion, Prioridad: selected.value })}
                      />
                    </div>
                    {errorsRelacion.Prioridad && (
                      <div className="invalid-feedback d-block">{errorsRelacion.Prioridad}</div>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Cantidad de llamadas por ronda</Form.Label>
                    <Form.Control
                      type="number"
                      name="Cant"
                      value={newRelacion.Cant || ''}
                      onChange={handleRelacionInputChange}
                      min="1"
                      placeholder='Select'
                      isInvalid={!!errorsRelacion.Cant}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errorsRelacion.Cant}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Button variant="primary" 
                    onClick={isEditandoRelacion ? handleActualizarRelacion : handleAgregarRelacion}
                    disabled={isSavingRelacion}
                  >
                    {isSavingRelacion
                      ? (isEditandoRelacion ? 'Guardando...' : 'Creando...')
                      : (isEditandoRelacion ? 'Guardar Cambios' : 'Guardar selección')}
                  </Button>
                  {isEditandoRelacion && (
                    <Button
                      variant="secondary"
                      className="ms-2"
                      onClick={() => {
                        setNewRelacion({ idServicio: '', Prioridad: '', Cant: '' });
                        setIsEditandoRelacion(false);
                      }}
                    >
                      Cancelar
                    </Button>
                  )}
                </Form>
                <div className="mt-4">
                  <div className="d-flex align-items-center mb-2">
                    <span
                      style={{
                        display: 'inline-block',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: '#d4edda',
                        marginRight: '8px',
                      }}
                    ></span>
                    Servicios para pantalla táctil
                  </div>
                  <div className="d-flex align-items-center">
                    <span
                      style={{
                        display: 'inline-block',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: '#f8d7da',
                        marginRight: '8px',
                      }}
                    ></span>
                    Servicios para cola interna
                  </div>
                </div>
              </div>
            )}
            {/* Columna derecha - Listado */}
            <div className={userRole === 'consulta' ? 'col-md-12' : 'col-md-8'}>
              <h5>Servicios asignados</h5>
              {relaciones.length === 0 ? (
                <p>No hay servicios asignados.</p>
              ) : (
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Servicio</th>
                      <th>Prioridad</th>
                      <th>Cantidad</th>
                      {userRole !== 'consulta' && (
                        <th>Opciones</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {relaciones.map(rel => (
                      <tr key={rel.id}>
                        <td>{rel.servicio?.Servicio || 'Sin nombre'}</td>
                        <td>{rel.Prioridad}</td>
                        <td>{rel.Cant}</td>
                        {userRole !== 'consulta' && (
                          <td>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => handleEditarRelacion(rel)}
                            >
                              <Pencil />
                            </Button>{' '}
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleEliminarRelacion(rel)}
                            >
                              <Trash />
                            </Button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Mensaje Toast */}
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toast.variant}
          onClose={() => setToast({ ...toast, show: false })}
          show={toast.show}
          delay={3000}
          autohide
        >
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Ventanillas;
